module.exports = __webpack_public_path__ + "static/media/gplay.8d0233f0.png";